magna.previewCarousel = () => {
  const container = document.querySelector('.preview__gallery-container');
  if (!container) return;

  const list = container.querySelector('.preview__gallery-list');
  const items = list.querySelectorAll('.preview__gallery-item:not(:empty)');
  const prevButton = container.querySelector('.button--prev');
  const nextButton = container.querySelector('.button--next');
  const dots = container.querySelector('.preview__dots');

  let currentIndex = 0;

  const updateCarousel = () => {
    list.style.transform = `translateX(-${currentIndex * 100}%)`;
    updateDots();
  };

  const createDots = () => {
    dots.innerHTML = ''; // Clear existing dots
    items.forEach((_, index) => {
      const dot = document.createElement('div');
      dot.classList.add('preview__dot');
      dot.addEventListener('click', () => {
        currentIndex = index;
        updateCarousel();
      });
      dots.appendChild(dot);
    });
  };

  const updateDots = () => {
    const allDots = dots.querySelectorAll('.preview__dot');
    allDots.forEach((dot, index) => {
      dot.classList.toggle('preview__dot--selected', index === currentIndex);
    });
  };

  prevButton.addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + items.length) % items.length;
    updateCarousel();
  });

  nextButton.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % items.length;
    updateCarousel();
  });

  createDots();
  updateCarousel();

  // Show dots container
  dots.style.display = 'flex';
};

window.addEventListener('DOMContentLoaded', () => {
  magna.previewCarousel();
});